/**
 * @deprecated This service is deprecated. Use UndoRedoManagerService from './undo-redo' instead.
 * The getTopLevelParents helper function is still exported from this file for backward compatibility.
 */

/**
 * Get the top-level parent nodes from a selection.
 * Filters out nodes whose parents are also in the selection.
 */
export function getTopLevelParents(nodes: any[]): string[] {
  const nodeSet = new Set(nodes.map(n => n.id()));
  const topLevelParents = new Set<string>();

  nodes.forEach(n => {
    let parent = n.parent();

    if (parent.empty()) {
      topLevelParents.add(n.id()); // Node is a root with no parent → include it
      return;
    }

    while (parent.nonempty()) {
      if (nodeSet.has(parent.id())) {
        parent = parent.parent();
      } else {
        topLevelParents.add(n.id()); // Fixed: Add the actual node ID, not the parent ID
        break;
      }
    }
  });

  return Array.from(topLevelParents);
}
